module.exports = __webpack_public_path__ + "images/instructor-randy-rosseel-mobile.webp";